import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

//  PLUGINS
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import '@/plugins/axios'

//  SERVICES
import constant from '@/services/constants'
import util from '@/services/util'
import validator from '@/services/validators'

//  COMPONENTS
import Icon from '@/components/icons/Icon'

Vue.component('Icon', Icon)

//  ADD SHORTCUT
Vue.use({
    install (Vue) {
        Vue.prototype.$constant = Vue.$constant = constant
        Vue.prototype.$util = Vue.$util = util
        Vue.prototype.$validator = Vue.$validator = validator
    }
})

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app')
